import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./src/styles/global.css";

// Font Awesome normally injects its CSS from JS at runtime, which lands after
// the statically-rendered icons have already painted unstyled and makes them
// jump. The stylesheet import above ships it in the CSS bundle instead.
config.autoAddCss = false;
